import { CoreIcon } from '../core-icon';
import coinCircleColorSVG from '../../assets/icons/coin-circle-color.svg';
import type { IconProps } from '../core-icon';

export const CoinCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={coinCircleColorSVG} {...props} />;
};
